import options from './accuracy-validation.component';

export default {
    selector: 'dtAccuracyValidation',
    options
};
